import {StringUtils} from '../../utils/string.utils';
import {ApiJsonResult} from '../../utils/api/apijsonresult';

export class User {
    emailAddress: string;
    password: string;
    childId: any;
    profileCreatedBy: string;
    userType: string;
    name: string;
    gender: string;
    dateOfBirth: string;
    country: string;
    phone: string;
    otp: string;
    postpaidAccount: string;
    scopePostpaidAccount: string;
    totsguideWebDomain: string;
    activationState: string;
    emailVerified: string;
    createdBy: string;
    createdDate: any;
    updatedBy: string;
    updatedDate: any;

    static populate(jsonObject: any): User {
        const obj = new User();
        obj.emailAddress = jsonObject.emailAddress;
        obj.password = jsonObject.password;
        obj.childId = jsonObject.childId;
        obj.profileCreatedBy = jsonObject.profileCreatedBy;
        obj.userType = jsonObject.userType;
        obj.name = jsonObject.name;
        obj.gender = jsonObject.gender;
        obj.dateOfBirth = jsonObject.dateOfBirth;
        obj.country = jsonObject.country;
        obj.phone = jsonObject.phone;
        obj.otp = jsonObject.otp;
        obj.postpaidAccount = jsonObject.postpaidAccount;
        obj.scopePostpaidAccount = jsonObject.scopePostpaidAccount;
        obj.totsguideWebDomain = jsonObject.totsguideWebDomain;
        obj.activationState = jsonObject.activationState;
        obj.emailVerified = jsonObject.emailVerified;
        obj.createdBy = jsonObject.createdBy;
        obj.createdDate = jsonObject.createdDate;
        obj.updatedBy = jsonObject.updatedBy;
        obj.updatedDate = jsonObject.updatedDate;
        return obj;
    }

    static loginform(jsonObject: any): User {
        const obj = new User();
        obj.emailAddress = jsonObject.emailAddress;
        obj.password = jsonObject.password;
        return obj;
    }

    static signupform(jsonObject: any): User {
        const obj = new User();
        obj.emailAddress = jsonObject.emailAddress;
        obj.password = jsonObject.password;
        obj.userType = jsonObject.userType;
        obj.name = jsonObject.name;
        obj.gender = jsonObject.gender;
        obj.dateOfBirth = jsonObject.dateOfBirth;
        obj.country = jsonObject.country;
        obj.phone = jsonObject.phone;
        obj.createdBy = jsonObject.createdBy;
        obj.createdDate = jsonObject.createdDate;
        obj.updatedBy = jsonObject.updatedBy;
        obj.updatedDate = jsonObject.updatedDate;
        return obj;
    }

    static apimapper(apijsonResult: ApiJsonResult): User {
        let obj = null;
        if (!StringUtils.isEmpty(apijsonResult.outputjson)) {
            const jsonObject = JSON.parse(apijsonResult.outputjson);
            obj = User.populate(jsonObject);
        }
        return obj;
    }

    static apimapperLst(apijsonResult: ApiJsonResult): User [] {
        const lst: User [] = [];
        if (!StringUtils.isEmpty(apijsonResult.outputjson)) {
            const jsonObject = JSON.parse(apijsonResult.outputjson);
            for (let i = 0; i < jsonObject.length; i++) {
                lst.push(User.populate(jsonObject[i]));
            }
            return lst;
        }
    }
}
